import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class InvoicesManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/invoices',
      params,
      paramsSerializer: qs.stringify,
    });

  show = (id) =>
    this.request({
      method: 'GET',
      url: `/invoices/${id}`,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/invoices',
      data,
    });

  recharge = (id) =>
    this.request({
      method: 'POST',
      url: `/invoices/${id}/recharge`,
    });

  convertToInternalBilling = (id) =>
    this.request({
      method: 'POST',
      url: `/invoices/${id}/convert-to-internal-billing`,
    });
}
